module.exports = __webpack_public_path__ + "static/img/数字化系统定制.70811261.png";